export default {
    bungie: 'https://www.bungie.net/',
    reddit: 'https://www.reddit.com/r/DestinyTheGame/',
}